export type CopyResult={status:'copied';method:'clipboard'|'selection'}|{status:'manual';method:'selection';reason:string}

/** Copy inside the user's click gesture, including plain HTTP LAN pages. */
function legacyCopy(text:string,container:HTMLElement):CopyResult{
  if(!text||typeof document==='undefined')return {status:'manual',method:'selection',reason:'链接内容为空'}
  const active=document.activeElement instanceof HTMLElement?document.activeElement:null
  const selection=document.getSelection(),ranges:Range[]=[]
  if(selection)for(let index=0;index<selection.rangeCount;index++)ranges.push(selection.getRangeAt(index).cloneRange())
  const scrollX=window.scrollX,scrollY=window.scrollY
  const input=document.createElement('textarea')
  input.value=text
  input.readOnly=true
  input.setAttribute('aria-label','临时复制内容')
  input.style.cssText='position:fixed;left:0;top:0;width:2px;height:2px;opacity:.01;pointer-events:none;z-index:2147483647'
  container.append(input)
  input.focus({preventScroll:true})
  input.select()
  input.setSelectionRange(0,input.value.length)
  let copied=false
  try{copied=document.execCommand('copy')}catch{copied=false}
  input.remove()
  if(active?.isConnected)active.focus({preventScroll:true})
  if(selection){selection.removeAllRanges();for(const range of ranges)selection.addRange(range)}
  window.scrollTo(scrollX,scrollY)
  return copied?{status:'copied',method:'selection'}:{status:'manual',method:'selection',reason:'浏览器拒绝了兼容复制命令'}
}

export async function copyText(text:string,container:HTMLElement=document.body):Promise<CopyResult>{
  if(!text)return {status:'manual',method:'selection',reason:'链接内容为空'}
  // Clipboard API is intentionally restricted on non-HTTPS LAN origins.
  // Use execCommand synchronously there so the click's user activation is kept.
  if(!window.isSecureContext||!navigator.clipboard?.writeText)return legacyCopy(text,container)
  try{
    await navigator.clipboard.writeText(text)
    return {status:'copied',method:'clipboard'}
  }catch(error){
    const fallback=legacyCopy(text,container)
    if(fallback.status==='copied')return fallback
    return {status:'manual',method:'selection',reason:error instanceof Error?error.message:fallback.reason}
  }
}

export function selectCopyText(input:HTMLInputElement|HTMLTextAreaElement|null):void{
  if(!input)return
  input.focus({preventScroll:true})
  input.select()
  input.setSelectionRange(0,input.value.length)
}
